"use client";

import * as React from "react";

import SidebarHistory from "@/components/sidebar/history";
import { Sidebar, SidebarContent } from "@EspaceParkQC/sdk-react";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar variant="inset" collapsible="offcanvas" {...props}>
      <SidebarContent>
        <SidebarHistory />
      </SidebarContent>
    </Sidebar>
  );
}
